import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  shipNoFrom: string;    // 交運單號[從]
  shipNoTo: string;      // 交運單號[至]
  shipDateFrom: string;  // 交運日期[從] YYYY-MM-DD
  shipDateTo: string;    // 交運日期[至] YYYY-MM-DD
  custFrom: string;      // 客戶代號[從]
  custTo: string;        // 客戶代號[至]
  invDateFrom: string;   // 開票日期[從] YYYY-MM-DD
  invDateTo: string;     // 開票日期[至] YYYY-MM-DD
  payDateFrom: string;   // 繳款日期[從] YYYY-MM-DD
  payDateTo: string;     // 繳款日期[至] YYYY-MM-DD
  payTypeFrom: string;   // 繳款類別[從]
  payTypeTo: string;     // 繳款類別[至]
  docStatus: number;     // 單據狀態 1=全部, 2=已核准
  reportTypes: number[]; // 報表版式 [1=日期別, 2=客戶別, 3=交運類別]
}

export interface ShipInvPayRow {
  shipNo: string;
  seqNo: number;
  shipDate: string | null;
  custCode: string;
  custName: string;
  currency: string;
  shipAmount: number;
  shipStatus: string;
  sourceType: string;
  payNo: string;
  paySeqNo: number;
  payShipRef: string;
  payAmount: number;
  payStatus: string;
  payDate: string | null;
  invReqNo: string;
  invSeqNo: number;
  invType: number;
  invTypeName: string;
  invDate: string | null;
  invNo: string;
  invAmount: number;
  invStatus: string;
  unbilledAmt: number;
  invPayDiffAmt: number;
}

export interface CurrencySummary {
  currency: string;
  shipAmount: number;
  invAmount: number;
  unbilledAmt: number;
  payAmount: number;
  invPayDiffAmt: number;
}

export interface QueryResponse {
  details: ShipInvPayRow[];
  currencySummaries: CurrencySummary[];
  totalCount: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const g319Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/g319/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/g319/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
